import React, {useEffect, useState} from "react";
import {DescriptionText, FlexContainer, H1Text, LeftBackButtonText, Spinner} from "../../design";
import BillingHistory from "./components/billinghistory";
import BaseSplitPage from "../../components/splitpage";
import {findSubscriptionLinkById, updateSubscriptionLink} from "../../api";
import PaymentMethodList from "./components/paymentmethodlist";
import SubscribedEmail from "./components/subscribedemail";
import CurrentSubscription from "./components/currentsubscription";
import Header from "./components/smallscreen/header";
import {SWIREPAY_URL} from "../../appconstants";
import Support from "../../components/support";
import SmallScreenFooter from "../../components/smallscreen/footer";
import getUniquePaymentTypes from "../../utils/getUniquePaymentTypes";

type Props = {
  history: {
    push: Function,
  },
}

const SubscriptionLink = (props:Props) => {

  const {match : { params : { id } }} = props;
  const [subscriptionLink, setSubscriptionLink] = useState(null);
  const [subscription, setSubscription] = useState(null);
  const [paymentMethod, setPaymentMethod] = useState(null);
  const [account, setAccount] = useState(null);
  const [emailRecipients, setEmailRecipients] = useState([]);
  const [isShowSpinner, setShowSpinner] = useState(false);
  const [subscribedEmailFormShow, setSubscribedEmailFormShow] = useState(false);
  const [backButtonUrl, setBackButtonUrl] = useState(SWIREPAY_URL);

  const { location: { pathname }} = props;

  useEffect(() => {
    if(id) {getSubscriptionLinkById(id);}
  },[id]);

  const getSubscriptionLinkById = async (subscriptionLinkId) => {
    if(subscriptionLinkId) {
      setShowSpinner(true);

      try {
        const value = await findSubscriptionLinkById(id);
        if(value) {
          setSubscriptionLink(value);
          setSubscription(value.subscription);
          setPaymentMethod(value.subscription && value.subscription.paymentMethod);
          setEmailRecipients(value.subscription && value.subscription.emailRecipientList);
          setAccount(value.account);
          setBackButtonUrl(value.redirectUri)
          const paymenttype = (value.subscription && value.subscription.paymentMethodType && value.subscription.paymentMethodType.length > 0) ? value.subscription.paymentMethodType[0] : '';
          const uniquePayments = getUniquePaymentTypes(value.account && value.account.supportedRecurringPaymentTypes);
          const paymentSelected = paymenttype ? (uniquePayments && uniquePayments.indexOf(paymenttype)) : 0;
          sessionStorage.setItem('slectedPayment', paymentSelected);
        }
      } catch (reason) {
        props.history.push(`${pathname}/error`);
      } finally {
        setShowSpinner(false)
      }
    }
  };

  const onSubmit = (value, e) => {
    setSubscribedEmailFormShow(true);
    let emails = [];
    if(emailRecipients) emails = [...emails, ...emailRecipients];
    emails = [...emails, value.email];
    setEmailRecipients(emails);
    const data = { emailRecipientList: emails};
    updateSubscription(subscriptionLink.gid, data);
    setSubscribedEmailFormShow(false);
  };

  const deleteSubscribedEmail = email => {
    emailRecipients.splice(emailRecipients.indexOf(email), 1);
    setEmailRecipients([...emailRecipients]);
    const data = { emailRecipientList: emailRecipients};
    updateSubscription(subscriptionLink.gid, data);
  };

  const updateSubscription = async (gid, data) => {
    setShowSpinner(true);
    try {
      const value = await updateSubscriptionLink(gid, data);
      if(value) {
        await getSubscriptionLinkById(id)
      }
    } finally {
      setShowSpinner(false)
    }
  };

  return (
    <BaseSplitPage
      left={
        <>
          <FlexContainer
            flexDirection="column"
            position="relative"
            display="block"
            height="100%"
          >
          <div>
            <H1Text>
              {account && account.name}
            </H1Text>
            <DescriptionText >
              {subscription && subscription.description}
            </DescriptionText>
          </div>
          <div style={{position: "sticky", top: "85%"}}>
            <Support phone={account && account.support && account.support.phone}
                     whiteLabel={account && account.whiteLabel}
                     email={account && account.support && account.support.email}/>
          </div>
          </FlexContainer>
        </>
      }
      right={
        <>
          <Header 
            account={account} 
            subscription={subscription}
            cancelUrlLink={null}
          />
          <FlexContainer
            className="pt-3 pt-lg-5 w-100"
            box-shadow="0 0 15px 0 rgba(0, 0, 0, 0.1)"
            display= "flow-root"
          >
            <CurrentSubscription subscription={subscription} account={account}/>
            <PaymentMethodList paymentMethod={paymentMethod} account={account} history={props.history}/>
            <SubscribedEmail emailRecipients={emailRecipients} add={onSubmit}  formShow={subscribedEmailFormShow} remove={deleteSubscribedEmail}/>
            <BillingHistory id={id} timeZone={account && account.timezone}/>
          </FlexContainer>
          <SmallScreenFooter phone={account && account.support && account.support.phone}
                             whiteLabel={account && account.whiteLabel}
                             email={account && account.support && account.support.email} children={""}/>
          <Spinner isOpen={isShowSpinner}/>
        </>
      }
    />
  )
};

export default SubscriptionLink
